module.exports = __webpack_public_path__ + "img/EC.381c85c9.svg";